import {Component} from '@angular/core';
import {NotificationService} from "./notification.service";

@Component({
    selector: 'toast',
    providers: [],
    templateUrl: './toast.component.html'
})
export class ToastComponent {
    constructor(private notificationService: NotificationService){
    }

    getToast(){
        return this.notificationService.getToast();
    }

    isToastVisible(){
        return this.notificationService.isToastVisible();
    }

    closeToast(){
        return this.notificationService.closeToast();
    }

    getClassIcon(){
        let className = 'eva-3-icon-info-circle -info';
        switch (this.notificationService.getToast().type) {
            case 'ERROR':
                className = 'eva-3-icon-error-circle -error';
                break;
            case 'INFO':
                className = 'eva-3-icon-info-circle -info';
                break;
            case 'SUCCESS':
                className = 'eva-3-icon-checkmark-circle -success';
                break;
        }
        return className;
    }

    getClassBody(){
        let className ='-info';
        switch (this.notificationService.getToast().type) {
            case 'ERROR':
                className = '-error';
                break;
            case 'INFO':
                className = '-info';
                break;
            case 'SUCCESS':
                className = '-success';
                break;
        }
        return className;
    }

    getMessageList(){
        return this.notificationService.getToast().messageList;
    }

}


// WEBPACK FOOTER //
// ./public/upgrade/root/toast/toast.component.ts